// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"889588f2","732":"951be55e"}[chunkId] + ".chunk.js";
};